import type { GameEntry } from '../types'

// ─── Penguin Games ────────────────────────────────────────────────────────────
import penguinRunImg from '../assets/img/penguin-run.png'
import mPenguinRunImg from '../assets/img/m-penguin-run.png'
import penguinIglooImg from '../assets/img/penguin-igloo.png'
import mPenguinIglooImg from '../assets/img/m-penguin-igloo.png'
import penguinFishingImg from '../assets/img/penguin-fishing.png'
import mPenguinFishingImg from '../assets/img/m-penguin-fishing.png'
import penguinHomecommingImg from '../assets/img/penguin-homecomming.png'
import mPenguinHomecommingImg from '../assets/img/m-penguin-homecomming.png'
import penguinMigrationImg from '../assets/img/penguin-migration.png'
import mPenguinMigrationImg from '../assets/img/m-penguin-migration.png'
import penguinGroundImg from '../assets/img/penguin-ground.png'
import mPenguinGroundImg from '../assets/img/m-penguin-ground.png'
import sphinxTreasureImg from '../assets/img/sphinx-treasure.png'
import mSphinxTreasureImg from '../assets/img/m-sphinx-treasure.png'
import watchMakerImg from '../assets/img/watch-maker.png'
import mWatchMakerImg from '../assets/img/m-watch-maker.png'
import hunterBearImg from '../assets/img/hunter-bear.png'
import mHunterBearImg from '../assets/img/m-hunter-bear.png'
import slimelabImg from '../assets/img/slimelab.png'
import mSlimelabImg from '../assets/img/m-slimelab.png'
import aqueariumImg from '../assets/img/aquearium.png'
import mAqueariumImg from '../assets/img/m-aquearium.png'
import penguincubeImg from '../assets/img/penguincube.png'
import mPenguincubeImg from '../assets/img/m-penguincube.png'
import alienDefenceImg from '../assets/img/alienDefence.png'
import mAlienDefenceImg from '../assets/img/m-alienDefence.png'
import dduckguckImg from '../assets/img/dduckguck.png'
import mDduckguckImg from '../assets/img/m-dduckguck.png'
import spaceBubbleImg from '../assets/img/spaceBubble.png'
import mSpaceBubbleImg from '../assets/img/m-spaceBubble.png'
import multipangpangImg from '../assets/img/multipangpang.png'
import mMultipangpangImg from '../assets/img/m-multipangpang.png'
import tentensImg from '../assets/img/tentens.png'
import mTentensImg from '../assets/img/m-tentens.png'
import rabbitfarmImg from '../assets/img/rabbitfarm.png'
import mRabbitfarmImg from '../assets/img/m-rabbitfarm.png'
import festivalImg from '../assets/img/festival.png'
import mFestivalImg from '../assets/img/m-festival.png'
import rabbitAlchemistImg from '../assets/img/rabbitAlchemist.png'
import mRabbitAlchemistImg from '../assets/img/m-rabbitAlchemist.png'
import rabbitTrainImg from '../assets/img/rabbitTrain.png'
import mRabbitTrainImg from '../assets/img/m-rabbitTrain.png'
import bubblesImg from '../assets/img/bubbles.png'
import mBubblesImg from '../assets/img/m-bubbles.png'
import detectiveImg from '../assets/img/detective.png'
import mDetectiveImg from '../assets/img/m-detective.png'
import explorerImg from '../assets/img/explorer.png'
import mExplorerImg from '../assets/img/m-explorer.png'
import snowfightImg from '../assets/img/snowfight.png'
import mSnowfightImg from '../assets/img/m-snowfight.png'
import plusbubbleImg from '../assets/img/plusbubble.png'
import mPlusbubbleImg from '../assets/img/m-plusbubble.png'
import quedugandImg from '../assets/img/quegudan.png'
import mQuedugandImg from '../assets/img/m-quegudan.png'
import quegudan2Img from '../assets/img/quegudan2.png'
import mQuegudan2Img from '../assets/img/m-quegudan2.png'
import starRoadImg from '../assets/img/star-road.png'
import mStarRoadImg from '../assets/img/m-starRoad.png'
import gameBlankImg from '../assets/img/game-blank-m.png'

// ─── Major-only (syu_) Games ──────────────────────────────────────────────────
import manmanImg from '../assets/img/manman.png'
import mManmanImg from '../assets/img/m-manman.png'
import caoftImg from '../assets/img/caoft.png'
import kkaebangjungImg from '../assets/img/kkaebangjung.png'
import sachicImg from '../assets/img/sachic.png'
import ddamiNemoImg from '../assets/img/ddami-nemo.png'
import mDdamiNemoImg from '../assets/img/m-ddamiNemo.png'
import kkaedaDragonImg from '../assets/img/kkaeda-dragon.png'

// ─── Kids Games ───────────────────────────────────────────────────────────────
import penguinRunKidsImg from '../assets/img/penguin-run-kids.png'
import penguinIglooKidsImg from '../assets/img/penguin-igloo-kids.png'
import penguinFishingKidsImg from '../assets/img/penguin-fishing-kids.png'
import penguinHomecommingKidsImg from '../assets/img/penguin-homecomming-kids.png'
import penguinMigrationKidsImg from '../assets/img/penguin-migration-kids.png'
import penguinGroundKidsImg from '../assets/img/penguin-ground-kids.png'
import slimelabKidsImg from '../assets/img/slimelab-kids.png'
import newTentensKidsImg from '../assets/img/new-tentens-kids.png'
import mNewTentensImg from '../assets/img/m-new-tentens.png'
import watchMakerKidsImg from '../assets/img/watch-maker-kids.png'
import spaceBubbleKidsImg from '../assets/img/spaceBubble-kids.png'

const gameRegistry: Record<string, GameEntry> = {
  // ─── Penguin Games ────────────────────────────────────────────────────────

  PenguinRun: {
    id: 'PenguinRun',
    ko: {
      name: '펭귄RUN',
      desc: '먹이를 구하러 떠나는 펭귄이 물에 빠지지 않게 숫자를 맞춰보세요.',
    },
    en: {
      name: 'Penguin Run',
      desc: 'The penguin is off to get food. Choose the right number so that the penguin does not fall into the water.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    concepts: ['counting', 'number'],
    image: penguinRunImg,
    mobileImage: mPenguinRunImg,
    loader: () => import('../games/penguin/JG01_p_run/PenguinRunComponent'),
  },

  PenguinGrouping: {
    id: 'PenguinGrouping',
    ko: {
      name: '펭귄이글루',
      desc: '주어진 숫자를 보면서 이글루를 몇 개 만들 수 있는지 알아보아요.',
    },
    en: {
      name: 'Penguin Igloo',
      desc: 'Referring to the number given, find out how many igloos can be made.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinIglooImg,
    mobileImage: mPenguinIglooImg,
    loader: () => import('../games/penguin/PenguinGrouping/PenguinGroupingComponent'),
  },

  PenguinFishing: {
    id: 'PenguinFishing',
    ko: {
      name: '펭귄낚시',
      desc: '어떻게 그물을 치면 물고기를 빨리 잡을 수 있을까요?',
    },
    en: {
      name: 'Penguin Fishing',
      desc: 'Think about the fastest way to cast a net to get fish.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinFishingImg,
    mobileImage: mPenguinFishingImg,
    loader: () => import('../games/penguin/PenguinFishing/PenguinFishingComponent'),
  },

  PenguinHomecoming: {
    id: 'PenguinHomecoming',
    ko: {
      name: '펭귄홈커밍',
      desc: '펭귄이 무사히 바다를 건널 수 있도록 십 묶음을 떠올리며 수의 단위를 즉시 맞춰보아요.',
    },
    en: {
      name: 'Penguin Coming Home',
      desc: 'Guess the correct digit thinking about ten bundles so that the penguin safely crosses the sea.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinHomecommingImg,
    mobileImage: mPenguinHomecommingImg,
    loader: () => import('../games/penguin/PenguinHomecomming/PenguinHomecommingComponent'),
  },

  PenguinMigration: {
    id: 'PenguinMigration',
    ko: {
      name: '펭귄대이동',
      desc: '함께 지내게 되는 펭귄들을 단위에 맞게 정렬하면 모두 몇 마리인지 알 수 있어요.',
    },
    en: {
      name: 'Penguin Great Migration',
      desc: '함께 지내게 되는 펭귄들을 단위에 맞게 정렬하면 모두 몇 마리인지 알 수 있어요.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinMigrationImg,
    mobileImage: mPenguinMigrationImg,
    loader: () => import('../games/penguin/PenguinMigration/PenguinMigrationComponent'),
  },

  PenguinGround: {
    id: 'PenguinGround',
    ko: {
      name: '펭귄그라운드',
      desc: '만질 수 있는 얼음벽돌의 여러가지 모양을 보고 그 이름과 특징을 알 수 있어요.',
    },
    en: {
      name: 'Penguin Ground',
      desc: 'Find out the names and features of various shapes of ice blocks.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinGroundImg,
    mobileImage: mPenguinGroundImg,
    loader: () => import('../games/penguin/PenguinCastle/PenguinCastleComponent'),
  },

  Penguin3D: {
    id: 'Penguin3D',
    ko: {
      name: '스핑크스의 보물',
      desc: '입체도형을 잘랐을 때 나온 모양을 떠올려보고 그 특징을 맞춰보아요.',
    },
    en: {
      name: 'Treasures of Sphinx',
      desc: 'Picture the plane figure cut from a solid figure and guess the features.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: sphinxTreasureImg,
    mobileImage: mSphinxTreasureImg,
    loader: () => import('../games/penguin/Penguin3D/Penguin3DComponent'),
  },

  watchMaker: {
    id: 'watchMaker',
    ko: {
      name: '만능시계공',
      desc: '현재 시각에 맞게 주어진 시계의 시와 분을 직접 맞춰서 고쳐보아요.',
    },
    en: {
      name: 'All-Round Repairman',
      desc: 'Fix the clocks by setting the correct hour and minute.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: watchMakerImg,
    mobileImage: mWatchMakerImg,
    loader: () => import('../games/penguin/watchMaker/watchMakerComponent'),
  },

  HunterBear: {
    id: 'HunterBear',
    ko: {
      name: '헌터베어',
      desc: '주어진 단위를 보고 같은 값을 나타내는 또 다른 단위를 골라 명중해보아요.',
    },
    en: {
      name: 'Hunter Bear',
      desc: 'Shoot the target which represents the same unit as the given one.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: hunterBearImg,
    mobileImage: mHunterBearImg,
    loader: () => import('../games/penguin/bowMaster/bowMasterComponent'),
  },

  slimeLab: {
    id: 'slimeLab',
    ko: {
      name: '슬라임 연구소',
      desc: '주어진 크기대로 슬라임이 커지려면 얼마나 더해야 하는지 그 변화를 맞춰보아요.',
    },
    en: {
      name: 'Slime Institute',
      desc: 'Find the change in order to make the slime as big as the given one.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: slimelabImg,
    mobileImage: mSlimelabImg,
    loader: () => import('../games/penguin/slimeLab/slimeLabComponent'),
  },

  Aquearium: {
    id: 'Aquearium',
    ko: {
      name: '아깨아리움',
      desc: '채우거나 빼야할 물의 양이 곧 더하거나 거꾸로 더한 변화라는 것을 알 수 있어요.',
    },
    en: {
      name: 'Aquearium',
      desc: 'The amount of water to pour in or take out represents the change of adding or the opposite of adding.',
    },
    type: 'transition',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: aqueariumImg,
    mobileImage: mAqueariumImg,
    loader: () => import('../games/penguin/Aquearium/AqueariumComponent'),
  },

  PenguinCube: {
    id: 'PenguinCube',
    ko: {
      name: '펭귄큐브',
      desc: '얼음벽돌을 옮기고 채워가면서 더하기와 빼기가 있는 식을 풀어보아요.',
    },
    en: {
      name: 'Penguin Cube',
      desc: 'Solve the equations by moving and filling in the ice bricks.',
    },
    type: 'transition',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguincubeImg,
    mobileImage: mPenguincubeImg,
    loader: () => import('../games/penguin/PenguinCube/PenguinCubeComponent'),
  },

  alienDefence: {
    id: 'alienDefence',
    ko: {
      name: '지구를 지켜라',
      desc: '터렛이 있는 위치로 트럭이 이동할 수 있도록 덧셈식 또는 뺄셈식을 만들어 주세요.',
    },
    en: {
      name: 'Save the Earth',
      desc: 'Make addition or subtraction equations to move the truck to right turret.',
    },
    type: 'transition',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: alienDefenceImg,
    mobileImage: mAlienDefenceImg,
    loader: () => import('../games/penguin/alienDefence/alienDefenceComponent'),
  },

  DDuckGuck: {
    id: 'DDuckGuck',
    ko: {
      name: '깨봉베이커리',
      desc: '주문서에 나온대로 빵을 자르고 빵의 길이를 나타내는 식을 세워 보아요.',
    },
    en: {
      name: 'Quebon Bakery',
      desc: 'Cut the bread according to the order form and make the equation which represents the length of the bread.',
    },
    type: 'transition',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: dduckguckImg,
    mobileImage: mDduckguckImg,
    loader: () => import('../games/penguin/DDuckGuck/DDuckGuckComponent'),
  },

  spaceBubble: {
    id: 'spaceBubble',
    ko: {
      name: '펭귄팩토리',
      desc: '두 수의 크기를 비교하여 알맞은 등호 또는 부등호가 있는 방향으로 얼음을 분류해 주세요.',
    },
    en: {
      name: 'Penguin Factory',
      desc: 'Sort the ice bricks to the correct direction of equality or inequality symbol by comparing two given numbers.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: spaceBubbleImg,
    mobileImage: mSpaceBubbleImg,
    loader: () => import('../games/penguin/spaceBubble/spaceBubbleComponent'),
  },

  MultiPangPang: {
    id: 'MultiPangPang',
    ko: {
      name: '곱셈팡팡',
      desc: '+, –, ×를 최소한의 횟수로 사용하여 주어진 색깔 블록의 모양으로 똑같이 만들어 보아요.',
    },
    en: {
      name: 'Multiplication Pop',
      desc: 'Make the same shape of color blocks using the least number of +, –, × operations.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: multipangpangImg,
    mobileImage: mMultipangpangImg,
    loader: () => import('../games/penguin/MultiPangPang/MultiPangPang'),
  },

  tentens: {
    id: 'tentens',
    ko: {
      name: '텐텐스',
      desc: '숫자의 합이 십 또는 2십이 되게 만들다 보면 십보수 개념이 자연스럽게 들어와요!',
    },
    en: {
      name: 'TENTENS',
      desc: 'Choosing the numbers making ten or 2 ten naturally helps think of the tens complements.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: tentensImg,
    mobileImage: mTentensImg,
    loader: () => import('../games/penguin/tentens/tentensComponent'),
  },

  lostTemple: {
    id: 'lostTemple',
    ko: {
      name: '래빗 팜',
      desc: '당근을 직사각형 모양의 밭에 심고 수확하면서 곱셈식을 풀고 당근의 개수를 구해 보아요.',
    },
    en: {
      name: 'Rabbit Farm',
      desc: 'Solve multiplication and get the number of carrots by planting and harvesting the carrots in the rectangular shaped field.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: rabbitfarmImg,
    mobileImage: mRabbitfarmImg,
    loader: () => import('../games/penguin/JG18_farm/FarmComponent'),
  },

  festival: {
    id: 'festival',
    ko: {
      name: '래빗 페스티벌',
      desc: '십으로 묶인 당근 조각들로 당근주스를 만들면서 나눗셈식의 몫과 나머지를 이해할 수 있어요.',
    },
    en: {
      name: 'Rabbit Festival',
      desc: 'Get the sense of quotient and remainder in division while making carrot juice using the carrot pieces grouped by ten.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: festivalImg,
    mobileImage: mFestivalImg,
    loader: () => import('../games/penguin/festival/festivalComponent'),
  },

  rabbitAlchemist: {
    id: 'rabbitAlchemist',
    ko: {
      name: '래빗 연금술',
      desc: '0을 더하거나 곱할 때, 또는 0으로 나누면 어떻게 변신이 되는지를 보고 0의 파워를 느껴 보아요.',
    },
    en: {
      name: 'Rabbit Alchemy',
      desc: "Feel the power of 0 by the change it brings when it's added, multiplied or divided.",
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: rabbitAlchemistImg,
    mobileImage: mRabbitAlchemistImg,
    loader: () => import('../games/penguin/JG20_r_alchemy/alchemistComponent'),
  },

  rabbitTrain: {
    id: 'rabbitTrain',
    ko: {
      name: '래빗 트레인',
      desc: '토끼 마릿수의 변화를 보면서 규칙을 알게 되면 몇 번째에는 토끼가 몇 마리인지 알 수 있어요.',
    },
    en: {
      name: 'Rabbit Train',
      desc: "It's easy to know how many rabbits there would be once you figure out the rule from the change in the number of rabbits.",
    },
    type: 'transition',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: rabbitTrainImg,
    mobileImage: mRabbitTrainImg,
    loader: () => import('../games/penguin/JG21_r_train/TrainComponent'),
  },

  bubbles: {
    id: 'bubbles',
    ko: {
      name: '버블즈',
      desc: '구슬의 개수를 곱셈식으로 나타낸 것을 보고 직사각형으로 표현할 수 있어요.',
    },
    en: {
      name: 'Bubbles',
      desc: 'Convert the number of marbles expressed in multiplications to rectangles.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: bubblesImg,
    mobileImage: mBubblesImg,
    loader: () => import('../games/penguin/JG22_bubbles/BubbleComponent'),
  },

  detective: {
    id: 'detective',
    ko: {
      name: '래빗 탐정',
      desc: '분자 또는 분모를 보고 주어진 분수들의 크기를 비교할 수 있어요. 작은 수부터 순서대로 이어보세요.',
    },
    en: {
      name: 'Rabbit Detective',
      desc: "It's possible to compare the size of fractions by looking at the numerators or denominators. Connect from the smallest number to the biggest.",
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: detectiveImg,
    mobileImage: mDetectiveImg,
    loader: () => import('../games/penguin/JG23_detective/DetectiveComponent'),
  },

  explorer: {
    id: 'explorer',
    ko: {
      name: '래빗 탐험대',
      desc: '부등호에 따라 주어진 수를 보고 알맞은 곳에 소수점을 찍어 보아요.',
    },
    en: {
      name: 'Rabbit Expedition',
      desc: 'Put a decimal point at the appropriate spot depending on the inequality symbol.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: explorerImg,
    mobileImage: mExplorerImg,
    loader: () => import('../games/penguin/JG24_explorer/ExplorerComponent'),
  },

  snowfight: {
    id: 'snowfight',
    ko: {
      name: '눈싸움 대결',
      desc: '여러 도형들을 돌려보고 확대·축소하면서 주어진 도형과 닮은 것이 무엇인지 찾아보세요.',
    },
    en: {
      name: 'Snow Fight',
      desc: 'Find the similar figure as the given one by rotating, enlarging or reducing.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: snowfightImg,
    mobileImage: mSnowfightImg,
    loader: () => import('../games/penguin/JG25_snowfight/SnowfightComponent'),
  },

  JG18Farm: {
    id: 'JG18Farm',
    ko: {
      name: '래빗 팜 (구)',
      desc: '당근을 직사각형 모양의 밭에 심고 수확하면서 곱셈식을 풀고 당근의 개수를 구해 보아요.',
    },
    en: {
      name: 'Rabbit Farm (Legacy)',
      desc: 'Solve multiplication and get the number of carrots by planting and harvesting the carrots.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: rabbitfarmImg,
    mobileImage: mRabbitfarmImg,
    loader: () => import('../games/penguin/JG18_farm/FarmComponent'),
  },

  JG18FarmReboot: {
    id: 'JG18FarmReboot',
    ko: {
      name: '래빗 팜 리부트',
      desc: '당근을 직사각형 모양의 밭에 심고 수확하면서 곱셈식을 풀고 당근의 개수를 구해 보아요.',
    },
    en: {
      name: 'Rabbit Farm Reboot',
      desc: 'Solve multiplication and get the number of carrots by planting and harvesting the carrots.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: rabbitfarmImg,
    mobileImage: mRabbitfarmImg,
    loader: () => import('../games/penguin/JG18_farm_reboot/FarmComponent'),
  },

  PlusBubble: {
    id: 'PlusBubble',
    ko: {
      name: '플러스 버블',
      desc: '10을 만들까? 7을 만들까? 원하는 숫자만큼 바닷속 버블을 연결해보세요!',
    },
    en: {
      name: 'PLUS BUBBLE',
      desc: "Should I make a 10? Make a 7? Connect the bubbles undersea until the number you want!",
    },
    type: 'casual',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: plusbubbleImg,
    mobileImage: mPlusbubbleImg,
    loader: () => import('../games/penguin/PlusBubble/PlusBubbleComponent'),
  },

  QueboardLight: {
    id: 'QueboardLight',
    ko: {
      name: '깨구단',
      desc: '곱하기는 직사각형! 떨어지는 곱셈 블럭과 수 블럭을 보고 직사각형 모양으로 알맞게 만들어 보아요.',
    },
    en: {
      name: 'Quegudan',
      desc: '곱하기는 직사각형! 떨어지는 곱셈 블럭과 수 블럭을 보고 직사각형 모양으로 알맞게 만들어 보아요.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: false,
    image: quedugandImg,
    mobileImage: mQuedugandImg,
    loader: () => import('../games/penguin/QueboardLight/QueboardLightComponent'),
  },

  Quegudan2: {
    id: 'Quegudan2',
    ko: {
      name: '깨구단2',
      desc: '곱하기를 보면 떠올려야 하는 건? 직사각형! 열 개씩 묶으면서 똑똑하고 빠르게 개수를 세어 보아요.',
    },
    en: {
      name: 'Quegudan2',
      desc: '곱하기를 보면 떠올려야 하는 건? 직사각형! 열 개씩 묶으면서 똑똑하고 빠르게 개수를 세어 보아요.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: false,
    image: quegudan2Img,
    mobileImage: mQuegudan2Img,
    loader: () => import('../games/penguin/Quegudan2/Quegudan2Component'),
  },

  StarRoad: {
    id: 'StarRoad',
    ko: {
      name: '스타로드',
      desc: '오늘 밤은 무슨 별자리가 보일까? 별자리와 함께 떠나는 선형대수학 우주여행!',
    },
    en: {
      name: 'STAR ROAD',
      desc: 'What constellations will we see tonight? Linear algebra space travel with the constellations!',
    },
    type: 'puzzle',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: starRoadImg,
    mobileImage: mStarRoadImg,
    loader: () => import('../games/penguin/StarRoad/StarRoadComponent'),
  },

  RJG06: {
    id: 'RJG06',
    ko: {
      name: 'RJG06',
      desc: '게임을 즐겨보세요.',
    },
    en: {
      name: 'RJG06',
      desc: 'Enjoy the game.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: false,
    junior: false,
    majorOnly: false,
    image: gameBlankImg,
    mobileImage: gameBlankImg,
    loader: () => import('../games/penguin/RJG06/RJG06Component'),
  },

  // ─── Major-only (syu_) Games ──────────────────────────────────────────────

  KMG: {
    id: 'KMG',
    ko: {
      name: '만만빵빵',
      desc: '팔천, 구천 다음은? 십천! 이걸 이미 알았다면 바로 도전해봐~',
    },
    en: {
      name: 'MAANMAAN BBANGBBANG',
      desc: 'Eight thousand, nine thousand, and then what? Ten thousand! If you know this already, try it right away.',
    },
    type: 'racing',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: false,
    image: manmanImg,
    mobileImage: mManmanImg,
    loader: () => import('../games/penguin/syu_mmbb/MMBBComponent'),
  },

  TriFunction: {
    id: 'TriFunction',
    ko: {
      name: '캐오트',
      desc: '으악! 몬스터들이 몰려오고 있잖아... 지금 깨다에겐 삼각함수 무기가 필요해!',
    },
    en: {
      name: 'CASTLE OF TRI-KNIGHT',
      desc: "Uhh! The monsters are coming... Quickie needs a triangulation weapon just right now!",
    },
    type: 'defense',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: caoftImg,
    mobileImage: caoftImg,
    loader: () => import('../games/penguin/syu_CoT/CoTComponent'),
  },

  Equation: {
    id: 'Equation',
    ko: {
      name: '깨방정',
      desc: '깨다와 연산 미사일을 모아 방정식을 풀며 우주를 여행하자~',
    },
    en: {
      name: 'BREAK DOWN',
      desc: "Let's take a trip to space, solve the equation, and collect the missiles with Quickie.",
    },
    type: 'shooting',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: kkaebangjungImg,
    mobileImage: kkaebangjungImg,
    loader: () => import('../games/penguin/syu_Equation/EquationComponent'),
  },

  ArithPuzzle: {
    id: 'ArithPuzzle',
    ko: {
      name: '사칙팡팡',
      desc: '깨다가 낸 사칙연산 퍼즐! 깨다의 콧대를 납작하게 눌러주자!',
    },
    en: {
      name: 'ARITH PANGPANG',
      desc: "Quickie is giving arithmetic operation puzzles! Let's dominate Quickie!",
    },
    type: 'puzzle',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: sachicImg,
    mobileImage: sachicImg,
    loader: () => import('../games/penguin/syu_ArithPuzzle/APComponent'),
  },

  Pizza: {
    id: 'Pizza',
    ko: {
      name: '따미의 네모피자',
      desc: '곱하기, 직사각형, 확률을 안다면 재료를 얻어 맛있는 피자를 만들어 보세요!',
    },
    en: {
      name: "SWEATIE'S PIZZA SHOP",
      desc: 'If you know multiplication, rectangle, and probability, make delicious pizzas with the ingredients.',
    },
    type: 'casual',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: ddamiNemoImg,
    mobileImage: mDdamiNemoImg,
    loader: () => import('../games/penguin/syu_PizzaStore/PizzaStoreComponent'),
  },

  DragonHunt: {
    id: 'DragonHunt',
    ko: {
      name: '깨다의 드래곤 헌팅',
      desc: '소인수분해로 용 잡으러 가자! 깨다의 드래곤 헌팅! 같이 떠나볼래?',
    },
    en: {
      name: "QUEDA'S DRAGON HUNTING",
      desc: "Let's hunt the dragon using factorization! Quickie's dragon hunting! Want to go on a journey with me?",
    },
    type: 'action',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: false,
    majorOnly: true,
    image: kkaedaDragonImg,
    mobileImage: kkaedaDragonImg,
    loader: () => import('../games/penguin/syu_DragonHunter/DHComponent'),
  },

  nemo: {
    id: 'nemo',
    ko: {
      name: '네모',
      desc: '게임을 즐겨보세요.',
    },
    en: {
      name: 'Nemo',
      desc: 'Enjoy the game.',
    },
    type: 'number',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: false,
    junior: false,
    majorOnly: false,
    image: ddamiNemoImg,
    mobileImage: mDdamiNemoImg,
    loader: () => import('../games/penguin/nemo/NemoComponent'),
  },

  // ─── Kids Games ───────────────────────────────────────────────────────────

  kidsPenguinRun: {
    id: 'kidsPenguinRun',
    ko: {
      name: '[Kids] 펭귄런',
      desc: '먹이를 구하러 떠나는 펭귄이 물에 빠지지 않게 숫자를 맞춰보세요.',
    },
    en: {
      name: 'Penguin Run (kids)',
      desc: 'The penguin is off to get food. Choose the right number so that the penguin does not fall into the water.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinRunKidsImg,
    mobileImage: mPenguinRunImg,
    loader: () => import('../games/kids/Kids_p_run/PenguinRunComponent'),
  },

  kidsPenguinFishing: {
    id: 'kidsPenguinFishing',
    ko: {
      name: '[Kids] 펭귄낚시',
      desc: '어떻게 그물을 치면 물고기를 빨리 잡을 수 있을까요?',
    },
    en: {
      name: 'Penguin Fishing (kids)',
      desc: 'Think about the fastest way to cast a net to get fish.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinFishingKidsImg,
    mobileImage: mPenguinFishingImg,
    loader: () => import('../games/kids/Kids_p_fishing/PenguinFishingComponent'),
  },

  kidsPenguinGrouping: {
    id: 'kidsPenguinGrouping',
    ko: {
      name: '[Kids] 펭귄이글루',
      desc: '주어진 숫자를 보면서 이글루를 몇 개 만들 수 있는지 알아보아요.',
    },
    en: {
      name: 'Penguin Igloo (kids)',
      desc: 'Referring to the number given, find out how many igloos can be made.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinIglooKidsImg,
    mobileImage: mPenguinIglooImg,
    loader: () => import('../games/kids/Kids_p_grouping/PenguinGroupingComponent'),
  },

  kidsPenguinHomecomming: {
    id: 'kidsPenguinHomecomming',
    ko: {
      name: '[Kids] 펭귄홈커밍',
      desc: '펭귄이 무사히 바다를 건널 수 있도록 십 묶음을 떠올리며 수의 단위를 즉시 맞춰보아요.',
    },
    en: {
      name: 'Penguin Coming Home (kids)',
      desc: 'Guess the correct digit thinking about ten bundles so that the penguin safely crosses the sea.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinHomecommingKidsImg,
    mobileImage: mPenguinHomecommingImg,
    loader: () => import('../games/kids/Kids_p_homecomming/PenguinHomecommingComponent'),
  },

  kidsPenguinMigration: {
    id: 'kidsPenguinMigration',
    ko: {
      name: '[Kids] 펭귄대이동',
      desc: '함께 지내게 되는 펭귄들을 단위에 맞게 정렬하면 모두 몇 마리인지 알 수 있어요.',
    },
    en: {
      name: 'Penguin Great Migration (kids)',
      desc: '함께 지내게 되는 펭귄들을 단위에 맞게 정렬하면 모두 몇 마리인지 알 수 있어요.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinMigrationKidsImg,
    mobileImage: mPenguinMigrationImg,
    loader: () => import('../games/kids/Kids_p_migration/PenguinMigrationComponent'),
  },

  kidsPenguinCastle: {
    id: 'kidsPenguinCastle',
    ko: {
      name: '[Kids] 펭귄그라운드',
      desc: '만질 수 있는 얼음벽돌의 여러가지 모양을 보고 그 이름과 특징을 알 수 있어요.',
    },
    en: {
      name: 'Penguin Ground',
      desc: 'Find out the names and features of various shapes of ice blocks.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: penguinGroundKidsImg,
    mobileImage: mPenguinGroundImg,
    loader: () => import('../games/kids/Kids_p_castle/PenguinCastleComponent'),
  },

  kidsSlimeLab: {
    id: 'kidsSlimeLab',
    ko: {
      name: '[Kids] 슬라임 연구소',
      desc: '주어진 크기대로 슬라임이 커지려면 얼마나 더해야 하는지 그 변화를 맞춰보아요.',
    },
    en: {
      name: 'Slime Institute',
      desc: 'Find the change in order to make the slime as big as the given one.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: slimelabKidsImg,
    mobileImage: mSlimelabImg,
    loader: () => import('../games/kids/Kids_slimeLab/slimeLabComponent'),
  },

  kidsTenTens: {
    id: 'kidsTenTens',
    ko: {
      name: '[Kids] 텐텐스',
      desc: '숫자의 합이 십 또는 2십이 되게 만들다 보면 십보수 개념이 자연스럽게 들어와요!',
    },
    en: {
      name: 'TENTENS',
      desc: 'Choosing the numbers making ten or 2 ten naturally helps think of the tens complements.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: newTentensKidsImg,
    mobileImage: mNewTentensImg,
    loader: () => import('../games/kids/Kids_tentens/tentensComponent'),
  },

  kidsWatchMaker: {
    id: 'kidsWatchMaker',
    ko: {
      name: '[Kids] 만능시계공',
      desc: '현재 시각에 맞게 주어진 시계의 시와 분을 직접 맞춰서 고쳐보아요.',
    },
    en: {
      name: 'All-Round Repairman (kids)',
      desc: 'Fix the clocks by setting the correct hour and minute.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: watchMakerKidsImg,
    mobileImage: mWatchMakerImg,
    loader: () => import('../games/kids/Kids_watchMaker/watchMakerComponent'),
  },

  kidsAquearium: {
    id: 'kidsAquearium',
    ko: {
      name: '[Kids] 아깨아리움',
      desc: '채우거나 빼야할 물의 양이 곧 더하거나 거꾸로 더한 변화라는 것을 알 수 있어요.',
    },
    en: {
      name: 'Aquearium (kids)',
      desc: 'The amount of water to pour in or take out represents the change of adding or the opposite of adding.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: aqueariumImg,
    mobileImage: mAqueariumImg,
    loader: () => import('../games/kids/Kids_aquearium/AqueariumComponent'),
  },

  kidsSapceBubble: {
    id: 'kidsSapceBubble',
    ko: {
      name: '[Kids] 펭귄팩토리',
      desc: '두 수의 크기를 비교하여 알맞은 등호 또는 부등호가 있는 방향으로 얼음을 분류해 주세요.',
    },
    en: {
      name: 'Penguin Factory (kids)',
      desc: 'Sort the ice bricks to the correct direction of equality or inequality symbol by comparing two given numbers.',
    },
    type: 'shape',
    runType: 'js',
    width: 1024,
    height: 768,
    mobile: true,
    junior: true,
    majorOnly: false,
    image: spaceBubbleKidsImg,
    mobileImage: mSpaceBubbleImg,
    loader: () => import('../games/kids/kids_p_spaceBubble/spaceBubbleComponent'),
  },
}

export function getGameRegistry(): GameEntry[] {
  return Object.values(gameRegistry)
}

export function getGameEntry(gameId: string): GameEntry | undefined {
  return gameRegistry[gameId]
}

export function filterGames(filters: {
  type?: string
  junior?: boolean
  mobile?: boolean
  majorOnly?: boolean
}): GameEntry[] {
  return Object.values(gameRegistry).filter((game) => {
    if (filters.type !== undefined && game.type !== filters.type) return false
    if (filters.junior !== undefined && game.junior !== filters.junior) return false
    if (filters.mobile !== undefined && game.mobile !== filters.mobile) return false
    if (filters.majorOnly !== undefined && game.majorOnly !== filters.majorOnly) return false
    return true
  })
}
